import axios from "axios";

export type Tag = {
    id: number;
    text: string;
    text_color: string;
    background_color: string;
    status?: string;
    department_id?: number | null;
};

export async function toggleSessionTagRequest(sessionId: number, tagId: number) {
    const { data } = await axios.post(
        `/operator/v4/tags/session/${sessionId}/toggle`,
        { tag_id: tagId }
    );

    return data as { success: boolean; session_id: number; tags: Tag[] };
}
